<template>
  <div>
    <!-- <v-row dense>
      <v-col sm="8"> </v-col>
      <v-col sm="2">
        <v-btn
          rounded
          outlined
          dense
          color="primary"
          v-on:click="ShowFilter"
          dark
          >Back To Search
        </v-btn>
      </v-col>
      <v-col sm="1">
        <v-btn
          rounded
          outlined
          dense
          color="primary"
          @click="exportoexcel()"
          dark
          >Download
        </v-btn>
      </v-col>
      <v-col sm="1"></v-col>
    </v-row> -->
 <v-row dense>
      <v-col align="right" >
        <v-btn rounded color="primary" v-on:click="ShowFilter" dark
          >Back To Search
        </v-btn>
      </v-col>
      <v-col align="right" sm=1>
        <download-excel
          :data="list"
          name="Sample Details"
          header="Sample Details"
         
        >
          <v-btn rounded color="primary" dark>Download </v-btn>
        </download-excel>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col sm=11>
        <v-data-table
          dense
          height="70vh"
          fixed-header
          :headers="Resultheaders"
          :items="list"
          :search="search"
          item-key="s_Key"
          :loading="isLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.sample_Point="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <a
                    :href="`/#/limsds/Sample-Detail?site=${item.site}&s_Key=${item.s_key}`"
                  >
                    {{ item.sample_Point }}
                  </a>
                </div>
              </template>
              <span>
                <span v-if="item.product != null">
                  Product : {{ item.product }}<br
                /></span>
                <span v-if="item.comment != null">
                  Comment : {{ item.comment }}<br
                /></span>
                <span v-if="item.batch_ID != null">
                  Batch ID : {{ item.batch_ID }}<br
                /></span>
                <span v-if="item.lab_Area != null">
                  Lab Area : {{ item.lab_Area }}<br
                /></span>
                <span v-if="item.lot_ID != null">
                  Lot ID : {{ item.lot_ID }}<br
                /></span>
                <span v-if="item.material_Number != null">
                  Material Number : {{ item.material_Number }}<br
                /></span>
                <span v-if="item.material_Description != null">
                  Material Description : {{ item.material_Description }}<br
                /></span>
              </span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Samples</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                dense
                outlined
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template> </v-data-table
      ></v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
export default {
  name: "SearchBySampleResult",
  mixins: [uiView, appMixin],
  props: {
    onlySamplesPreviousYear: { type: String, default: "1" },
    SelectedSite: { type: String, default: "" },
    SelectedUnit: { type: String, default: "" },
    SelectedArea: { type: String, default: "" },
    SelectedGroup: { type: String, default: "" },
    SamplePointAPI: { type: String, default: "" },
    ProductAPI: { type: String, default: "" },
    SampleDescAPI: { type: String, default: "" },
    TestAPI: { type: String, default: "" },
    BatchIDAPI: { type: String, default: "" },
    MaterialNumAPI: { type: String, default: "" },
    MaterialDescAPI: { type: String, default: "" },
    CommentAPI: { type: String, default: "" },
    SelectedLimitComp: { type: String, default: "-1" },
    StartDate: { type: String, default: "01/01/2000" },
    EndDate: { type: String, default: "01/12/2021" },
    userId: { type: String, default: "" },
    lims_internal: { type: String, default: "0" },
  },
  data() {
    return {
      search: "",
      list: [],
      Samplelist: {},
      SampleListResult: {},
      isLoading: false,
      DisplayText: "",
      selectedItem: [],
      Resultheaders: [],
    };
  },
  created() {
    this.fetchSampleList();
  },
  mounted() {},
  methods: {
    Details(item) {
      this.selectedItem = item;
    },
    ShowFilter() {
      this.$emit("ShowFilterHideResult", "Data from child to parents");
    },
    fetchSampleList() {
      let that = this;
      this.isLoading = true;
      const link =
        that.settings.WASampleList2 +
        "withSampleLastYear=" +
        this.onlySamplesPreviousYear +
        "&site=" +
        this.SelectedSite +
        "&unit=" +
        this.SelectedUnit +
        "&area=" +
        this.SelectedArea +
        "&group=" +
        this.SelectedGroup +
        "&pointmask=" +
        this.SamplePointAPI +
        "&descmask=" +
        this.SampleDescAPI +
        "&comment=" +
        this.CommentAPI +
        "&productid=" +
        this.ProductAPI +
        "&batchid=" +
        this.BatchIDAPI +
        "&materialnum=" +
        this.MaterialNumAPI +
        "&materialdesc=" +
        this.MaterialDescAPI +
        "&hasoffspec=" +
        this.SelectedLimitComp +
        "&testid=" +
        this.TestAPI +
        "&early=" +
        this.StartDate +
        "&late=" +
        this.EndDate +
        "&userid=" +
        this.limsds_userDetails.userEmail +
        "&lims_internal=" +
        this.lims_internal +
        "";

      axios.get(link).then((response) => {
        that.Samplelist = response.data;
        console.warn(that.Samplelist);
        that.SampleListResult = "<root>";
        that.SampleListResult += that.Samplelist.sampleListSecure2s
          .map((e) => {
            return `<sx s_key="${e.s_key}"/>`;
          })
          .join("");
        that.SampleListResult += "</root>";
        that.fetchSampleListResult();
      });
    },

    fetchSampleListResult() {
      let that = this;
      const link =
        that.settings.WASearchBySampleResult +
        "site=" +
        this.SelectedSite +
        "&userid=" +
        this.limsds_userDetails.userEmail +
        "&ipaddress=10.15.0.68&samplelist=" +
        that.SampleListResult +
        "&lims_internal=" +
        this.lims_internal +
        "&componentorder=0";

      axios.get(link).then((response) => {
        var columnsIn = response.data[0];
        // loop through every key in the object
        that.Resultheaders = [];
        for (var key in columnsIn) {
          if (key == "s_key") {
            that.DisplayText = "S Key";
          } else if (key == "site") {
            that.DisplayText = "Site";
          } else if (key == "sample_Point") {
            that.DisplayText = "Sample Point";
          } else if (key == "sample_Time") {
            that.DisplayText = "Sample Time";
          } else if (key == "description") {
            that.DisplayText = "Description";
          } else if (key == "comment") {
            that.DisplayText = "Comment";
          } else if (key == "batch_ID") {
            that.DisplayText = "Batch ID";
          } else if (key == "lot_ID") {
            that.DisplayText = "Lot ID";
          } else if (key == "lab_Area") {
            that.DisplayText = "Lab Area";
          } else if (key == "material_Number") {
            that.DisplayText = "Material Number";
          } else if (key == "material_Description") {
            that.DisplayText = "Material Description";
          } else if (key == "product") {
            that.DisplayText = "Product";
          } else {
            that.DisplayText = key.replace("<br/>", "");
            //that.DisplayText = key;
          }

          if (
            key != "s_key" &&
            key != "comment" &&
            key != "product" &&
            key != "batch_ID" &&
            key != "lot_ID" &&
            key != "lab_Area" &&
            key != "material_Number" &&
            key != "material_Description"
          ) {
            that.Resultheaders.push({ text: that.DisplayText, value: key });
          }
        }
        that.list = response.data;
        //}
        this.isLoading = false;

        console.warn(that.list);
        console.warn(that.Resultheaders);
      });
    },
    exportoexcel() {
      //this.download = true
      this.JSONToCSVConvertor(this.list, "Sample Details", true);
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      debugger;
      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      // //Set Report title in first row or line
      // CSV += ReportTitle + "\r\n\n";
      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row = "";
        //This loop will extract the label from 1st index of on array
        var colHCount = 0;
        for (var index in arrData[0]) {
          //Now convert each value to string and comma-seprated
          if (colHCount >= 2 && colHCount < 110) {
            row += index.toString().toUpperCase() + ",";
          }
          colHCount++;
        }
        row = row.slice(0, -1);
        //append Label row with line break
        CSV += row + "\r\n";
      }
      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = "";
        //2nd loop will extract each column and convert it in string comma-seprated
        var colCount = 0;
        for (var index in arrData[i]) {
          if (colCount >= 2 && colCount < 110) {
            row += '"' + arrData[i][index] + '",';
          }
          colCount++;
        }
        row.slice(0, row.length - 1);
        //add a line break after each row
        CSV += row + "\r\n";
      }
      if (CSV == "") {
        alert("Invalid data");
        return;
      }
      var filename = ReportTitle + ".csv";
      var blob = new Blob([CSV], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },
};
</script>